
<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <!-- 卡片-主体 -->
        <md-card-content>
          <h4 class="title">
            <div class="title-span">{{$I18n("push_platform_set")}}</div>
            <md-button @click="table_addItem('plat-add')" class="md-primary md-sm md-info right-button md-just-icon md-round">
              <md-icon>add</md-icon>
            </md-button>
          </h4>
          <md-table v-model="plat_ema_tableData">
            <md-table-row slot="md-table-row" slot-scope="{ item }" >
              <md-table-cell :md-label="$I18n('id')">{{ item.id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('name')">{{ item.name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('userid')">{{ item.user_id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('zone')">{{ item.zone }}</md-table-cell>
              <md-table-cell :md-label="$I18n('state')">{{ item.state_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('smtp_addr')">{{ item.smtp_addr }}</md-table-cell>
              <md-table-cell :md-label="$I18n('smtp_port')">{{ item.smtp_port }}</md-table-cell>
              <md-table-cell :md-label="$I18n('ssl_state')">{{ item.ssl_state_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('operate')"  class="button-box">
                <md-button @click="table_editItem(item, 'plat-ema-edit')" class="md-just-icon md-round md-info left-icon">
                  <md-icon>edit</md-icon>
                </md-button>
                <md-button @click="table_deleteItem(item, 'plat-ema-delete')" class="md-just-icon md-round md-danger md-info">
                  <md-icon>close</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state">{{$I18n("none_data")}}</md-table-empty-state>
          </md-table>
          <!-- 翻页 -->
          <table-page :total="plat_ema_total" :pageSize="pageSize" v-model="plat_ema_pageNo"/>
        </md-card-content>
      </md-card>
    </div>

    <div class="md-layout-item md-size-100">
      <md-card>
        <!-- 卡片-主体 -->
        <md-card-content>
          <h4 class="title">
            <div class="title-span">{{$I18n("push_template_set")}}</div>
            <md-button @click="table_addItem('temp-add')" class="md-primary md-sm md-info right-button md-just-icon md-round">
              <md-icon>add</md-icon>
            </md-button>
          </h4>
          <md-table v-model="temp_ema_tableData">
            <md-table-row slot="md-table-row" slot-scope="{ item }" >
              <md-table-cell :md-label="$I18n('id')">{{ item.id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('name')">{{ item.name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('title')">{{ item.title }}</md-table-cell>
              <md-table-cell :md-label="$I18n('type')">{{ item.type_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('language')">{{ item.lang_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('param')">{{ item.param }}</md-table-cell>
              <md-table-cell :md-label="$I18n('operate')"  class="button-box">
                <md-button @click="table_editItem(item, 'temp-ema-edit')" class="md-just-icon md-round md-info left-icon">
                  <md-icon>edit</md-icon>
                </md-button>
                <md-button @click="table_deleteItem(item, 'temp-ema-delete')" class="md-just-icon md-round md-danger md-info">
                  <md-icon>close</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state">{{$I18n("none_data")}}</md-table-empty-state>
          </md-table>
          <!-- 翻页 -->
          <table-page :total="temp_ema_total" :pageSize="pageSize" v-model="temp_ema_pageNo"/>
        </md-card-content>
      </md-card>
    </div>

    <!-- 弹窗 -->
    <simple-modal 
      ref    = "modal"
      :title = "modalTitle"
      :right = "!openModalType.includes('delete')"
      @submit= "modal_submit"
      :submitBtn = "openModalType !=='import'"
    >
      <template slot="body">
        <!-- 删除弹窗 -->
        <div v-if="openModalType.includes('delete')">{{$I18n("check_delete", modalData.name)}}</div>
        <!-- 添加/修改弹窗 -->
        <div v-else-if="openModalType.includes('add') || openModalType.includes('edit') ">
          <!-- E-Mail 平台 -->
          <div v-if="openModalType.includes('plat-ema')">
            <!-- 名字 -->
            <modal-form-item :label='$I18n("name") ' :required="true">
              <md-field :class="{'md-error' : error.name}">
                <md-input v-model="modalData.name"/>
                <md-icon v-if="error.name">clear</md-icon>
              </md-field>
            </modal-form-item>
            <!-- 公司 -->
            <modal-form-item :label='$I18n("company")'>
              <md-field>
                <md-select v-model="modalData.comp_path">
                  <md-option v-for="i in companys" :key="i.comp_path" :value="i.comp_path">{{i.comp_short_name ?i.comp_short_name :i.comp_name}}</md-option>
                </md-select>
              </md-field>
            </modal-form-item>
            <!-- 区域 -->
            <modal-form-item :label='$I18n("zone") ' :required="true">
              <md-field :class="{'md-error' : error.zone}">
                <md-input v-model="modalData.zone"/>
                <md-icon v-if="error.zone">clear</md-icon>
              </md-field>
            </modal-form-item>
            <!-- SMTP 地址 -->
            <modal-form-item :label='$I18n("smtp_addr") ' :required="true">
              <md-field :class="{'md-error' : error.smtp_addr}">
                <md-input v-model="modalData.smtp_addr"/>
                <md-icon v-if="error.smtp_addr">clear</md-icon>
              </md-field>
            </modal-form-item>
            <!-- SMTP 端口 -->
            <modal-form-item :label='$I18n("smtp_port") ' :required="true">
              <md-field :class="{'md-error' : error.smtp_port}">
                <md-input v-model="modalData.smtp_port"/>
                <md-icon v-if="error.smtp_port">clear</md-icon>
              </md-field>
            </modal-form-item>
            <!-- 发件人邮箱 -->
            <modal-form-item :label='$I18n("from_mail") ' :required="true">
              <md-field :class="{'md-error' : error.email_from}">
                <md-input v-model="modalData.email_from"/>
                <md-icon v-if="error.email_from">clear</md-icon>
              </md-field>
            </modal-form-item>
            <!-- 用户ID -->
            <modal-form-item :label='$I18n("userid") ' :required="true">
              <md-field :class="{'md-error' : error.user_id}">
                <md-input v-model="modalData.user_id"/>
                <md-icon v-if="error.user_id">clear</md-icon>
              </md-field>
            </modal-form-item>
            <!-- 用户密码 -->
            <modal-form-item :label='$I18n("password") ' :required="true">
              <md-field :class="{'md-error' : error.password}">
                <md-input v-model="modalData.password"/>
                <md-icon v-if="error.password">clear</md-icon>
              </md-field>
            </modal-form-item>
            <!-- SSL -->
            <modal-form-item :label='$I18n("ssl")'>
              <md-field>
                <md-select v-model="modalData.ssl">
                  <md-option :value="1">{{$I18n("open")}}</md-option>
                  <md-option :value="2">{{$I18n("close")}}</md-option>
                </md-select>
              </md-field>
            </modal-form-item>
            <!-- 状态 -->
            <modal-form-item :label='$I18n("state")'>
              <md-field>
                <md-select v-model="modalData.state">
                  <md-option :value="1">{{$I18n("open")}}</md-option>
                  <md-option :value="2">{{$I18n("close")}}</md-option>
                </md-select>
              </md-field>
            </modal-form-item>
          </div>
          <!-- E-Mail 模板 -->
          <div v-else-if="openModalType.includes('temp-ema')">
            <!-- 名字 -->
            <modal-form-item :label='$I18n("name") ' :required="true">
              <md-field :class="{'md-error' : error.name}">
                <md-input v-model="modalData.name"/>
                <md-icon v-if="error.name">clear</md-icon>
              </md-field>
            </modal-form-item>
            <!-- 公司 -->
            <modal-form-item :label='$I18n("company")'>
              <md-field>
                <md-select v-model="modalData.comp_path">
                  <md-option v-for="i in companys" :key="i.comp_path" :value="i.comp_path">{{i.comp_short_name ?i.comp_short_name :i.comp_name}}</md-option>
                </md-select>
              </md-field>
            </modal-form-item>
            <!-- 标题 -->
            <modal-form-item :label='$I18n("title") ' :required="true">
              <md-field :class="{'md-error' : error.title}">
                <md-input v-model="modalData.title"/>
                <md-icon v-if="error.title">clear</md-icon>
              </md-field>
            </modal-form-item>
            <!-- 参数 -->
            <modal-form-item :label='$I18n("param") '>
              <md-field>
                <md-input v-model="modalData.param"/>
              </md-field>
            </modal-form-item>
            <!-- 类型 -->
            <modal-form-item :label='$I18n("type")'>
              <md-field>
                <md-select v-model="modalData.notify_type">
                  <md-option v-for="i in $Param.notifyType" :key="'email_'+i.id" :value="i.id">
                    {{$I18n(i.name)}}
                  </md-option>
                </md-select>
              </md-field>
            </modal-form-item>
            <!-- 语言 -->
            <div class="md-layout">
              <modal-form-item 
                :label='$I18n("lang")' 
                :class="{'md-layout-item md-size-50 left-layout': modalData.lang === 'other'}">
                <md-field>
                  <md-select v-model="modalData.lang">
                    <md-option v-for="item in languageList" :key="item.short_name" :value="item.short_name">{{item.ch_name}}</md-option>
                  </md-select>
                </md-field>
              </modal-form-item>
            </div>
            <!-- 主干 -->
            <modal-form-item :label='$I18n("body") ' :required="true">
              <md-field :class="{'md-error' : error.body}">
                <md-textarea v-model="modalData.body"></md-textarea>
                <md-icon v-if="error.body">clear</md-icon>
              </md-field>
            </modal-form-item>
          </div>
        </div>
      </template>
    </simple-modal>
  </div>
</template>
<script>
// import { timestampToString1000 } from "@/common/tools.js";
import {languageInfo} from "@/common/languageInfo.js";
export default {
  components: { },
  data() {
    let languageList = [{
      short_name  : "ALL",
      ch_name: "全部",
    }];
    for(var key in languageInfo){
      languageList.push(languageInfo[key]);
    }
    return {
      languageList,
      // 表格相关
      // Table 原始数据 (翻页)
      ... ({
        plat_ema_tableInitData: [],
        plat_ema_pageNo   : 1,
        plat_ema_total    : 0,

        temp_ema_tableInitData: [],
        temp_ema_pageNo   : 1,
        temp_ema_total    : 0,
        
      }),
      // 每页的数量(统一)
      pageSize: 10,
      // 弹窗相关
      ... ({
        openModal     : false, // 是否打开弹窗
        openModalType : "",    // 弹窗类型
        modalTitle    : "",    // 弹窗标题
        // 弹窗表单相关
        modalData : {  },
        // 弹窗表单报错相关
        error: {},
      }),
      companys : [],
    };
  },
  computed:{
    // 表格数据处理
    ... ({
      plat_ema_tableData(){
        // plat_ema_tableInitData
        return [...this.plat_ema_tableInitData]
          .splice((this.plat_ema_pageNo-1) * this.pageSize, this.pageSize)
          .map(item => {
            let state_name = "";
            switch (item.state) {
              case 1:
                state_name = this.$I18n("open");
                break;
              case 2:
                state_name = this.$I18n("close");
                break;
              default :
                state_name = this.$I18n("unknow");
                break;
            }
            let ssl_state_name = "";
            switch (item.ssl) {
              case 1:
                ssl_state_name = this.$I18n("open");
                break;
              case 2:
                ssl_state_name = this.$I18n("close");
                break;
              default :
                ssl_state_name = this.$I18n("unknow");
                break;
            }
            return {
              ...item,
              ssl_state_name,
              state_name,
            }
          })
      },
      temp_ema_tableData(){
        // temp_ema_tableInitData
        return [...this.temp_ema_tableInitData]
          .splice((this.temp_ema_pageNo-1) * this.pageSize, this.pageSize)
          .map(item => {
            let type_name = this.$I18n(this.$Param.notifyType.getName(item.notify_type, "unknow"));
            let lang_name = "";
            switch (item.lang) {
              case "en":
                lang_name = "en(" + this.$I18n("en") + ")";
                break;
              case "zh-TW" :
                lang_name = "zh-TW(" + this.$I18n("zh-TW") + ")";
                break;
              case "zh-CN":
                lang_name = "zh-CN(" + this.$I18n("zh-CN") + ")";
                break;
              default :
                var langNameObj = this.languageList.filter(i => i.short_name == item.lang)[0];
                if(langNameObj){
                  lang_name = langNameObj.ch_name
                } else {
                  lang_name = item.lang;
                }
                break;
            }
            return {
              ...item,
              type_name,
              lang_name,
            }
          })
      },
    }),
  },
  watch:{
    'modalData.mode':{
      handler(newValue){
        if(newValue && this.openModalType.includes("add")){
          if(newValue == 3){
            this.modalData.notify_type = 0;
          } else {
            this.modalData.notify_type = 1;
          }
        }
      }
    },
  },
  mounted(){
    this.$api.getCompanyList({})
      .then(this.$Then(res => {
        this.companys = res.data.map(item => ({
          ...item,
          comp_path: item.path,
        }));
      }))
      .catch(this.$Catch());

    this.api_getPlatEmaData();
    this.api_getTempEmaData();
  },
  methods: {
    // 唤起/关闭 弹窗
    ... ({
      // 添加
      table_addItem(type){
        this.error = {};
        var initCompPath = ""
        const initComp = this.companys.filter(i => {i.comp_id == this.UserInfo.comp_id})[0];
        if(initComp){
          initCompPath = initComp.path;
        } else {
          initCompPath = this.companys[0]?.path;
        }
        if (type.includes("plat")) {
          this.modalTitle = this.$I18n("push_platform_set");
          this.openModalType = "plat-ema-add";
          this.modalData = {
            name       : "",
            zone       : "ALL",
            smtp_addr  : "",
            smtp_port  : "",
            user_id    : "",
            password   : "",
            ssl        : 1,
            state      : 1,
            email_from : "",
            comp_path     : initCompPath,
          };
        } else if(type.includes("temp")) {
          this.modalTitle = this.$I18n("push_template_set");
          this.openModalType = "temp-ema-add";
          this.modalData = {
            name       : "",
            title      : "",
            param      : "",
            lang       : "en",
            body       : "",
            notify_type: 1,
            type       : 2,
            comp_path     : initCompPath,
          };
        }
        this.$refs.modal.open();
      },
      // 修改
      table_editItem(dataItem, type){
        this.modalTitle = this.$I18n("push_platform_set");
        if(type.includes("temp")){
          this.modalTitle = this.$I18n("push_template_set");
        }
        this.modalData = {...dataItem};
        this.error = {};
        this.openModalType = type;
        this.$refs.modal.open();
      },
      // 删除
      table_deleteItem(dataItem, type){
        this.modalTitle = this.$I18n("push_platform_set");
        if(type.includes("temp")){
          this.modalTitle = this.$I18n("push_template_set");
        }
        this.modalData = {...dataItem};
        this.openModalType = type;
        this.$refs.modal.open();
      },
      // 关闭弹窗
      modal_classicModalHide (){
        this.$refs.modal.close();
        setTimeout(() => {
          this.$refs.modal.close();
          this.modalData = {};
          this.error = {};
        }, 300);
      },
      // 提交表单
      modal_submit() {
        this[this.openModalType.replaceAll("-","_")]();
      },
    }),
    // 提交表单相关 (共18个) 以及其他相关的方法
    ... ({
      // E-Mail 平台相关
      ...({
        // 校验
        plat_ema_check () {
          // error 初始化
          if(Object.keys(this.error).length === 0) {
            this.error = {
              name      : false,
              zone      : false,
              smtp_addr : false,
              smtp_port : false,
              user_id   : false,
              password  : false,
              email_from: false,
            };
          }
          this.key_check_only_required();
          return this.error_check();
        },
        plat_ema_add () {
          if (this.plat_ema_check()){
            this.$api.addVoicePlatform({
              ...this.modalData,
              type: 2,
            })
              .then(this.$Then(res => {
                this.simple_success(res);
                this.plat_ema_pageNo = 1;
                this.api_getPlatEmaData();
              }))
              .catch(this.$Catch(this.$I18n("fail_num")))
          }
        },
        plat_ema_edit () {
          if (this.plat_ema_check()){
            this.$api.editVoicePlatform({
              ...this.modalData,
              type: 2,
            })
              .then(this.$Then(res => {
                this.simple_success(res);
                this.plat_ema_pageNo = 1;
                this.api_getPlatEmaData();
              }))
              .catch(this.$Catch(this.$I18n("fail_num")))
          }
        },
        plat_ema_delete () {
          this.$api.delVoicePlatform({
            ...this.modalData,
            type: 2,
          })
            .then(this.$Then(res => {
              this.simple_success(res);
              this.plat_ema_pageNo = 1;
              this.api_getPlatEmaData();
            }))
            .catch(this.$Catch(this.$I18n("fail_num")))
        },
      }),
      // E-Mail 模板相关
      ...({
        temp_ema_check () {
          // error 初始化
          if(Object.keys(this.error).length === 0) {
            this.error = {
              name     : false,
              title    : false,
              body     : false,
            };
          }
          for(let key in this.error){
            if(!this.modalData[key]) {
              this.$errorMsg(this.$I18n("pls_input") + " " + this.$I18n(key));
            }
            this.error[key] = !this.modalData[key];
          }
          return this.error_check();
        },
        temp_ema_add () {
          if (this.temp_ema_check()){
            this.$api.addVoiceTemplate({
              ...this.modalData,
              type : 2,
              body : this.modalData.body?this.modalData.body.replace(/'/g,"\\'") :"",
            })
              .then(this.$Then(res => {
                this.simple_success(res);
                this.temp_ema_pageNo = 1;
                this.api_getTempEmaData();
              }))
              .catch(this.$Catch(this.$I18n("fail_num")))
          }
        },
        temp_ema_edit () {
          if (this.temp_ema_check()){
            this.$api.editVoiceTemplate({
              ...this.modalData,
              type : 2,
              body : this.modalData.body?this.modalData.body.replace(/'/g,"\\'") :"",
            })
              .then(this.$Then(res => {
                this.simple_success(res);
                this.temp_ema_pageNo = 1;
                this.api_getTempEmaData();
              }))
              .catch(this.$Catch(this.$I18n("fail_num")))
          }
        },
        temp_ema_delete () {
          this.$api.delVoiceTemplate({
            ...this.modalData,
            type : 2,
          })
            .then(this.$Then(res => {
              this.simple_success(res);
              this.temp_ema_pageNo = 1;
              this.api_getTempEmaData();
            }))
            .catch(this.$Catch(this.$I18n("fail_num")))
        },
      }),

      // 回调成功处理
      simple_success (res) {
        if(res.code === 200){
          this.$successMsg(this.$I18n("succ_num"));
          this.$refs.modal.close();
        } else {
          throw new Error ("unknown_error")
        }
      },
      // 表单检测 返回一个是否合格 (boolean) (false为不合格, true为合格)
      error_check () {
        for (let key in this.error) {
          if (this.error[key]) {
            return false;
          }
        }
        return true;
      },
      // 校验所有需要检验的key(只有必填)
      key_check_only_required () {
        for(let key in this.error){
          if(!this.modalData[key]) {
            this.$errorMsg(this.$I18n("pls_input") + " " + this.$I18n(key));
          }
          this.error[key] = !this.modalData[key];
        }
      },
    }),
    // 查询表格数据
    ... ({
      api_getPlatEmaData (){
        this.$api.getVoicePlatform({type: 2})
          .then(this.$Then(res => {
            this.plat_ema_tableInitData = res.data ?res.data :[];
            this.plat_ema_total = res.data? res.data.length :0;
          }))
          .catch(this.$Catch(this.$I18n("get_error"),() => {
            this.plat_ema_tableInitData = [];
            this.plat_ema_total = 0;
          }))
      },
      api_getTempEmaData (){
        this.$api.getVoiceTemplate({type: 2})
          .then(this.$Then(res => {
            this.temp_ema_tableInitData = res.data ?res.data :[];
            this.temp_ema_total = res.data? res.data.length :0;
          }))
          .catch(this.$Catch(this.$I18n("get_error"),() => {
            this.temp_ema_tableInitData = [];
            this.temp_ema_total = 0;
          }))
      },
    }),
    updateIndex(newIndex){
      this.startIndex = newIndex;
    },
    updateIndexTemp(newIndex){
      this.startIndexTemp = newIndex;
    },
  },
};
</script>
<style lang="scss" scoped>
  h4.title{
    display: flex;
    align-items: center;
  }
  h4.title .title-span{
    flex: 1;
    font-weight: 600 !important;
    font-size: 21px !important;
  }
  .left-layout{
    padding-left: 0;
  }
  .right-layout{
    padding-right: 0;
  }
  .md-card-only-title{
    margin: 0;
    box-shadow: none;
    text-align: left;
    position: relative;
    top: -12px;
    left: -20px;
  }
  .md-card-only-title .title{
    text-align:left !important;
  }
  .total-page{
    width: 30%;
    display: inline-block;
  }
  .left-btn {
    text-align:left;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .left-table{
    margin-top: 16px;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-rigth:8px;
    padding-left:8px;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }

  // 表单里的单选框
  .radio-layout{
    margin-top: 6px;
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 120px;
  }
  //左侧iocn
  .left-icon{
    margin-right: 16px;
  }
  // flaot 右的按钮
  .right-button {
    float:right;
  }

  .text-right .md-table-cell-container {
    display: flex;
    justify-content: flex-end;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }

  .table-stats {
    display: flex;
    align-items: center;
    text-align: right;
    flex-flow: row wrap;

    .td-price .td-total {
      display: inline-flex;
      font-weight: 500;
      font-size: 1.0625rem;
      margin-right: 50px;
    }

    &.table-striped .td-price {
      border-bottom: 0;
    }

    .td-price {
      font-size: 26px;
      border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
    }

    .td-price,
    > div {
      flex: 0 0 100%;
      padding: 12px 8px;
    }
  }
</style>